import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import Intro from "../../elements/blocks/intro";
import ThreeCxQueuesModal from "../../elements/reports/3cx-queues-modal";
import ThreeCxDownloadsModal from "../../elements/reports/3cx-downloads-modal";
export default function ThreeCxReports() {
    const { t } = useTranslation();
    const [manageOpen, setManageOpen] = useState(false);
    const [downloadOpen, setDownloadOpen] = useState(false);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("reports.3cx.title"), breadcrumbs: [
                    {
                        name: t("reports.3cx.title"),
                        link: "/3cx-reports",
                    },
                ], button: {
                    label: t("reports.3cx.download"),
                    color: "secondary",
                    type: "new",
                    action: () => setDownloadOpen(true),
                }, button2: {
                    label: t("reports.3cx.queue-settings.manage"),
                    color: "outlined",
                    type: "edit",
                    action: () => setManageOpen(true),
                } }), _jsx(ThreeCxQueuesModal, { open: manageOpen, onClose: () => setManageOpen(false) }), _jsx(ThreeCxDownloadsModal, { open: downloadOpen, onClose: () => setDownloadOpen(false) })] }));
}
